/* tslint:disable */
import { Injectable } from '@angular/core';
import { Branding } from '../../models/Branding';
import { ColorSettings } from '../../models/ColorSettings';
import { CustomerUrl } from '../../models/CustomerUrl';
import { FormattedAddress } from '../../models/FormattedAddress';
import { Announcement } from '../../models/Announcement';
import { Category } from '../../models/Category';
import { CheckIn } from '../../models/CheckIn';
import { Client } from '../../models/Client';
import { Comment } from '../../models/Comment';
import { Customer } from '../../models/Customer';
import { CustomerMemo } from '../../models/CustomerMemo';
import { FileRecord } from '../../models/FileRecord';
import { ImportLog } from '../../models/ImportLog';
import { Invitation } from '../../models/Invitation';
import { NotificationPreference } from '../../models/NotificationPreference';
import { CustomerEvent } from '../../models/CustomerEvent';
import { NotificationRecord } from '../../models/NotificationRecord';
import { Member } from '../../models/Member';
import { Memo } from '../../models/Memo';
import { MemoEvent } from '../../models/MemoEvent';
import { ModelEvent } from '../../models/ModelEvent';
import { Organisation } from '../../models/Organisation';
import { OrganisationFeedback } from '../../models/OrganisationFeedback';
import { OrganisationPreference } from '../../models/OrganisationPreference';
import { PermissionRequest } from '../../models/PermissionRequest';
import { Categories } from '../../models/Categories';
import { Customers } from '../../models/Customers';
import { CustomerProfile } from '../../models/CustomerProfile';
import { Files } from '../../models/Files';
import { Memos } from '../../models/Memos';
import { Organisations } from '../../models/Organisations';
import { AnnouncementRequest } from '../../models/AnnouncementRequest';
import { AnnouncementUpdateRequest } from '../../models/AnnouncementUpdateRequest';
import { CategoryRequest } from '../../models/CategoryRequest';
import { CheckInRequest } from '../../models/CheckInRequest';
import { CommentRequest } from '../../models/CommentRequest';
import { CustomerRequest } from '../../models/CustomerRequest';
import { CustomerSetting } from '../../models/CustomerSetting';
import { DeviceRequest } from '../../models/DeviceRequest';
import { FileToken } from '../../models/FileToken';
import { InvitationRequest } from '../../models/InvitationRequest';
import { MemberRequest } from '../../models/MemberRequest';
import { MemoActionRequest } from '../../models/MemoActionRequest';
import { MemoRequest } from '../../models/MemoRequest';
import { MemoStatsRequest } from '../../models/MemoStatsRequest';
import { NotificationPreferencesRequest } from '../../models/NotificationPreferencesRequest';
import { OrganisationCategorySettingsRequest } from '../../models/OrganisationCategorySettingsRequest';
import { OrganisationRequest } from '../../models/OrganisationRequest';
import { OrganisationFeedbackRequest } from '../../models/OrganisationFeedbackRequest';
import { PermissionApiRequest } from '../../models/PermissionApiRequest';
import { PermissionResponseRequest } from '../../models/PermissionResponseRequest';
import { PushRequest } from '../../models/PushRequest';
import { ResetRequest } from '../../models/ResetRequest';
import { SignupRequest } from '../../models/SignupRequest';
import { TentativePermissionRequest } from '../../models/TentativePermissionRequest';
import { UpdateMemberDetailsRequest } from '../../models/UpdateMemberDetailsRequest';
import { CommentResponse } from '../../models/CommentResponse';
import { CustomerActivityResponse } from '../../models/CustomerActivityResponse';
import { CustomerResponse } from '../../models/CustomerResponse';
import { CustomerImportResponse } from '../../models/CustomerImportResponse';
import { CustomerLimitedResponse } from '../../models/CustomerLimitedResponse';
import { CustomerMinimalResponse } from '../../models/CustomerMinimalResponse';
import { InvitationResponse } from '../../models/InvitationResponse';
import { JsonWebToken } from '../../models/JsonWebToken';
import { MemberActivityResponse } from '../../models/MemberActivityResponse';
import { MemberResponse } from '../../models/MemberResponse';
import { MemoResponse } from '../../models/MemoResponse';
import { MemoStatsResponse } from '../../models/MemoStatsResponse';
import { OrganisationFeedItem } from '../../models/OrganisationFeedItem';
import { OrganisationPreferenceRemote } from '../../models/OrganisationPreferenceRemote';
import { OrganisationResponse } from '../../models/OrganisationResponse';
import { PendingInvitationResponse } from '../../models/PendingInvitationResponse';
import { PermissionApiResponse } from '../../models/PermissionApiResponse';
import { ProfileResponse } from '../../models/ProfileResponse';
import { Migration } from '../../models/Migration';
import { MigrationMap } from '../../models/MigrationMap';
var SDKModels = /** @class */ (function () {
    function SDKModels() {
        this.models = {
            Branding: Branding,
            ColorSettings: ColorSettings,
            CustomerUrl: CustomerUrl,
            FormattedAddress: FormattedAddress,
            Announcement: Announcement,
            Category: Category,
            CheckIn: CheckIn,
            Client: Client,
            Comment: Comment,
            Customer: Customer,
            CustomerMemo: CustomerMemo,
            FileRecord: FileRecord,
            ImportLog: ImportLog,
            Invitation: Invitation,
            NotificationPreference: NotificationPreference,
            CustomerEvent: CustomerEvent,
            NotificationRecord: NotificationRecord,
            Member: Member,
            Memo: Memo,
            MemoEvent: MemoEvent,
            ModelEvent: ModelEvent,
            Organisation: Organisation,
            OrganisationFeedback: OrganisationFeedback,
            OrganisationPreference: OrganisationPreference,
            PermissionRequest: PermissionRequest,
            Categories: Categories,
            Customers: Customers,
            CustomerProfile: CustomerProfile,
            Files: Files,
            Memos: Memos,
            Organisations: Organisations,
            AnnouncementRequest: AnnouncementRequest,
            AnnouncementUpdateRequest: AnnouncementUpdateRequest,
            CategoryRequest: CategoryRequest,
            CheckInRequest: CheckInRequest,
            CommentRequest: CommentRequest,
            CustomerRequest: CustomerRequest,
            CustomerSetting: CustomerSetting,
            DeviceRequest: DeviceRequest,
            FileToken: FileToken,
            InvitationRequest: InvitationRequest,
            MemberRequest: MemberRequest,
            MemoActionRequest: MemoActionRequest,
            MemoRequest: MemoRequest,
            MemoStatsRequest: MemoStatsRequest,
            NotificationPreferencesRequest: NotificationPreferencesRequest,
            OrganisationCategorySettingsRequest: OrganisationCategorySettingsRequest,
            OrganisationRequest: OrganisationRequest,
            OrganisationFeedbackRequest: OrganisationFeedbackRequest,
            PermissionApiRequest: PermissionApiRequest,
            PermissionResponseRequest: PermissionResponseRequest,
            PushRequest: PushRequest,
            ResetRequest: ResetRequest,
            SignupRequest: SignupRequest,
            TentativePermissionRequest: TentativePermissionRequest,
            UpdateMemberDetailsRequest: UpdateMemberDetailsRequest,
            CommentResponse: CommentResponse,
            CustomerActivityResponse: CustomerActivityResponse,
            CustomerResponse: CustomerResponse,
            CustomerImportResponse: CustomerImportResponse,
            CustomerLimitedResponse: CustomerLimitedResponse,
            CustomerMinimalResponse: CustomerMinimalResponse,
            InvitationResponse: InvitationResponse,
            JsonWebToken: JsonWebToken,
            MemberActivityResponse: MemberActivityResponse,
            MemberResponse: MemberResponse,
            MemoResponse: MemoResponse,
            MemoStatsResponse: MemoStatsResponse,
            OrganisationFeedItem: OrganisationFeedItem,
            OrganisationPreferenceRemote: OrganisationPreferenceRemote,
            OrganisationResponse: OrganisationResponse,
            PendingInvitationResponse: PendingInvitationResponse,
            PermissionApiResponse: PermissionApiResponse,
            ProfileResponse: ProfileResponse,
            Migration: Migration,
            MigrationMap: MigrationMap,
        };
    }
    SDKModels.prototype.get = function (modelName) {
        return this.models[modelName];
    };
    SDKModels.prototype.getAll = function () {
        return this.models;
    };
    SDKModels.prototype.getModelNames = function () {
        return Object.keys(this.models);
    };
    SDKModels.decorators = [
        { type: Injectable },
    ];
    return SDKModels;
}());
export { SDKModels };
//# sourceMappingURL=SDKModels.js.map